import { useMemo, useState } from "react";
import VideoCard from "@/components/base/VideoCard";
import EmptyState from "@/components/base/EmptyState";
import { getLatestVideos } from "@/utils/video";

const tabs = [
  { id: "all", label: "全部" },
  { id: "drama", label: "影视剧" },
  { id: "variety", label: "综艺" },
  { id: "original", label: "原创" },
  { id: "anime", label: "动漫" },
  { id: "documentary", label: "纪录片" },
];

export default function LatestGrid() {
  const [tab, setTab] = useState("all");
  const latest = getLatestVideos(12);

  const list = useMemo(
    () => (tab === "all" ? latest : latest.filter((v) => v.categoryId === tab)),
    [tab, latest],
  );

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-5">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setTab(t.id)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
              tab === t.id
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {list.length === 0 ? (
        <EmptyState
          title="该分类暂无最新更新"
          description="换个分类看看吧，更多精彩内容正在路上。"
        />
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {list.map((v, i) => (
            <VideoCard key={v.id} video={v} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}